import React from 'react';
import { Box, Container, Typography, Link as MuiLink, styled } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { LINKS } from '../lib/links';

const productLinks = [
    { to: '/platform', label: 'Platform', isRouter: true },
    { to: '/pricing', label: 'Pricing', isRouter: true },
];

const companyLinks = [{ to: '/company', label: 'About us', isRouter: true }];

const resourcesLinks = [{ to: '/resources', label: 'Resources', isRouter: true }];

const contactLinks = [
    // { to: '/demo', label: 'Book a demo', isRouter: true },
    { to: '/contact', label: 'Contact us', isRouter: true },
];

const Footer = () => {
    const location = useLocation();
    const isHome = location.pathname === '/';

    return (
        <FooterRoot component="footer">
            <Container maxWidth="lg">
                <FooterGrid>
                    <BrandColumn>
                        <LogoRow>
                            <LogoImg src={`${process.env.PUBLIC_URL}/assets/logo.png`} alt="Medzhub Logo" />
                            <TextLogoImg src={`${process.env.PUBLIC_URL}/assets/Textlogo.png`} alt="Medzhub" />
                        </LogoRow>
                        <BrandDescriptionPanel>
                            <BrandDescription component="p">
                                <span className="brand-desc-lead">One system</span>
                                <span className="brand-desc-rest">
                                    {' '}
                                    for home care providers who manage field and in-house teams.
                                </span>
                            </BrandDescription>
                        </BrandDescriptionPanel>
                        {/* <CompanyBox>
                            <CompanyGlow />
                            <CompanyLabel>Company</CompanyLabel>
                            <CompanyName>Dhruthzuci Tech Solutions Pvt. Ltd.</CompanyName>
                        </CompanyBox> */}
                    </BrandColumn>

                    <SectionColumn>
                        <SectionTitle>Product</SectionTitle>
                        <LinksList>
                            {productLinks.map((item) => (
                                <li key={item.label}>
                                    {item.isRouter ? (
                                        <FooterLink component={Link} to={item.to}>
                                            {item.label}
                                        </FooterLink>
                                    ) : isHome ? (
                                        <FooterLink href={item.href}>{item.label}</FooterLink>
                                    ) : (
                                        <FooterLink
                                            component={Link}
                                            to="/"
                                            state={{ homeSection: item.href.replace(/^#/, '') }}
                                        >
                                            {item.label}
                                        </FooterLink>
                                    )}
                                </li>
                            ))}
                        </LinksList>
                    </SectionColumn>

                    <SectionColumn>
                        <SectionTitle>Company</SectionTitle>
                        <LinksList>
                            {companyLinks.map((item) => (
                                <li key={item.label}>
                                    <FooterLink component={Link} to={item.to}>
                                        {item.label}
                                    </FooterLink>
                                </li>
                            ))}
                        </LinksList>
                    </SectionColumn>

                    <SectionColumn>
                        <SectionTitle>Resources</SectionTitle>
                        <LinksList>
                            {resourcesLinks.map((item) => (
                                <li key={item.label}>
                                    <FooterLink component={Link} to={item.to}>
                                        {item.label}
                                    </FooterLink>
                                </li>
                            ))}
                        </LinksList>
                    </SectionColumn>

                    <SectionColumn>
                        <SectionTitle>Contact</SectionTitle>
                        <LinksList sx={{ mb: 2 }}>
                            {contactLinks.map((item) => (
                                <li key={item.label}>
                                    <FooterLink component={Link} to={item.to}>
                                        {item.label}
                                    </FooterLink>
                                </li>
                            ))}
                        </LinksList>
                        <ContactBlock>
                            <ContactLabel>WhatsApp</ContactLabel>
                            <FooterLink href="https://wa.me/919187644794" target="_blank" rel="noopener noreferrer">
                                +91 9187644794
                            </FooterLink>
                        </ContactBlock>
                        <ContactBlock>
                            <ContactLabel>Email</ContactLabel>
                            <FooterLink href="mailto:medzhub@eshatechgroup.com">
                                medzhub@eshatechgroup.com
                            </FooterLink>
                        </ContactBlock>
                        <ContactBlock>
                            <ContactLabel>Office</ContactLabel>
                            <FooterLink
                                href="https://www.google.com/maps/place/DhruthZuci+Tech+Solutions+Pvt+Ltd/@13.0220926,77.6516364,17z/data=!3m1!4b1!4m6!3m5!1s0x3bae112bfca27b21:0x2c3b82b3a90dd91c!8m2!3d13.0220926!4d77.6542113!16s%2Fg%2F11f540ntyr?entry=ttu"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{ display: 'block', lineHeight: 1.6 }}
                            >
                                Dhruthzuci Tech Solutions Pvt. Ltd.<br />
                                2nd floor, 208 Ramya Nivasa,<br />
                                7th cross Shakthi nagar, Horamavu,<br />
                                Bangalore - 560043
                            </FooterLink>
                        </ContactBlock>
                    </SectionColumn>

                    <SectionColumn>
                        <SectionTitle>Mobile Application</SectionTitle>
                        <StoreBadgesStack>
                            <StoreBadgeAnchor
                                href={LINKS.PLAY_STORE_APP}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <StoreBadgeImg
                                    src={`${process.env.PUBLIC_URL}/assets/Play Store.jpg`}
                                    alt="Get it on Google Play"
                                />
                            </StoreBadgeAnchor>
                            <StoreBadgeAnchor
                                href={LINKS.APP_STORE_APP}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <StoreBadgeImg
                                    src={`${process.env.PUBLIC_URL}/assets/App Store.jpg`}
                                    alt="Download on the App Store"
                                />
                            </StoreBadgeAnchor>
                        </StoreBadgesStack>
                    </SectionColumn>
                </FooterGrid>

                <FooterBottom>
                    <BottomBarLinks>
                        <FooterLink component={Link} to="/privacy">
                            Privacy Policy
                        </FooterLink>
                        <BottomBarSep aria-hidden>·</BottomBarSep>
                        <FooterLink component={Link} to="/terms">
                            Terms of Service
                        </FooterLink>
                    </BottomBarLinks>
                </FooterBottom>
            </Container>
        </FooterRoot>
    );
};

// Styled components
const FooterRoot = styled(Box)({
    background: 'linear-gradient(180deg, #F7F9FC 0%, #FFFFFF 100%)',
    borderTop: '1px solid #E5E7EB',
    paddingTop: '72px',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '3px',
        background: 'linear-gradient(90deg, transparent 0%, rgba(0, 102, 255, 0.4) 50%, transparent 100%)',
    },
    '@media (max-width: 768px)': {
        paddingTop: '60px',
    },
    '@media (max-width: 480px)': {
        paddingTop: '50px',
    },
});

const FooterGrid = styled(Box)({
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 1fr 1fr 1.25fr 1fr',
    gap: '64px 48px',
    paddingBottom: '48px',
    marginBottom: 0,
    borderBottom: '2px solid rgba(0, 102, 255, 0.08)',
    '@media (max-width: 1024px)': {
        gridTemplateColumns: '1fr 1fr',
        gap: '48px 40px',
    },
    '@media (max-width: 768px)': {
        gridTemplateColumns: '1fr',
        gap: '40px',
        paddingBottom: '32px',
    },
    '@media (max-width: 480px)': {
        gap: '36px',
        paddingBottom: '28px',
    },
});

const BrandColumn = styled(Box)({
    maxWidth: '380px',
    '@media (max-width: 768px)': {
        maxWidth: '100%',
    },
});

const LogoRow = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    // marginBottom: '6px',
});

const LogoImg = styled('img')({
    height: '80px',
    width: 'auto',
    objectFit: 'contain',
    filter: 'drop-shadow(0 2px 4px rgba(0, 102, 255, 0.1))',
    '@media (max-width: 768px)': {
        height: '56px',
    },
    '@media (max-width: 480px)': {
        height: '36px',
    },
});

const TextLogoImg = styled('img')({
    height: 'auto',
    width: '120px',
    objectFit: 'contain',
    filter: 'drop-shadow(0 2px 4px rgba(0, 102, 255, 0.1))',
    '@media (max-width: 768px)': {
        height: '56px',
    },
    '@media (max-width: 480px)': {
        height: '50px',
    },
});

// const LogoText = styled(Typography)({
//     fontSize: '28px',
//     fontWeight: 700,
//     background: 'linear-gradient(135deg, #0066FF 0%, #6366F1 100%)',
//     WebkitBackgroundClip: 'text',
//     WebkitTextFillColor: 'transparent',
//     backgroundClip: 'text',
//     letterSpacing: '-0.8px',
//     '@media (max-width: 480px)': {
//         fontSize: '22px',
//     },
// });

const BrandDescriptionPanel = styled(Box)({
    position: 'relative',
    marginTop: '18px',
    padding: '18px 20px 18px 24px',
    borderRadius: '14px',
    background:
        'linear-gradient(152deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 255, 0.98) 42%, rgba(241, 245, 255, 0.85) 100%)',
    border: '1px solid rgba(0, 102, 255, 0.11)',
    boxShadow:
        '0 1px 0 rgba(255, 255, 255, 0.9) inset, 0 10px 32px rgba(15, 23, 42, 0.06), 0 2px 8px rgba(0, 102, 255, 0.04)',
    overflow: 'hidden',
    '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: '14px',
        bottom: '14px',
        width: '4px',
        borderRadius: '0 6px 6px 0',
        background: 'linear-gradient(180deg, #0066FF 0%, #4F46E5 48%, #0891B2 100%)',
    },
    '@media (max-width: 480px)': {
        marginTop: '14px',
        padding: '15px 16px 15px 20px',
        borderRadius: '12px',
        '&::before': {
            top: '12px',
            bottom: '12px',
        },
    },
});

const BrandDescription = styled(Typography)({
    fontSize: '15px',
    lineHeight: 1.65,
    color: '#475569',
    fontWeight: 500,
    letterSpacing: '-0.011em',
    margin: 0,
    maxWidth: '22rem',
    '& .brand-desc-lead': {
        fontWeight: 800,
        letterSpacing: '-0.04em',
        fontSize: 'clamp(15px, 1.15vw, 17px)',
        background: 'linear-gradient(100deg, #0066FF 0%, #4F46E5 45%, #0E7490 95%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
    },
    '& .brand-desc-rest': {
        color: '#64748B',
        fontWeight: 500,
    },
    '@media (max-width: 480px)': {
        fontSize: '14px',
        maxWidth: '100%',
    },
});

// const CompanyBox = styled(Box)({
//     position: 'relative',
//     marginTop: '24px',
//     padding: '20px',
//     background: 'linear-gradient(135deg, rgba(0, 102, 255, 0.06) 0%, rgba(99, 102, 241, 0.06) 100%)',
//     borderRadius: '12px',
//     borderLeft: '4px solid #0066FF',
//     boxShadow: '0 2px 8px rgba(0, 102, 255, 0.08)',
//     overflow: 'hidden',
// });

// const CompanyGlow = styled(Box)({
//     position: 'absolute',
//     top: '-20px',
//     right: '-20px',
//     width: '80px',
//     height: '80px',
//     background: 'radial-gradient(circle, rgba(0, 102, 255, 0.1) 0%, transparent 70%)',
//     borderRadius: '50%',
// });

// const CompanyLabel = styled(Typography)({
//     fontSize: '11px',
//     fontWeight: 700,
//     color: '#0066FF',
//     textTransform: 'uppercase',
//     letterSpacing: '1px',
//     marginBottom: '8px',
// });

// const CompanyName = styled(Typography)({
//     fontSize: '16px',
//     fontWeight: 700,
//     color: '#111827',
//     letterSpacing: '-0.3px',
//     lineHeight: 1.4,
// });

const SectionColumn = styled(Box)({});

const StoreBadgesStack = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    alignItems: 'flex-start',
});

const StoreBadgeAnchor = styled('a')({
    display: 'block',
    textDecoration: 'none',
    maxWidth: '160px',
    transition: 'opacity 0.2s ease, transform 0.2s ease',
    '&:hover': {
        opacity: 0.92,
        transform: 'scale(1.02)',
    },
    '&:focus-visible': {
        outline: '2px solid #0066FF',
        outlineOffset: '4px',
        borderRadius: '8px',
    },
});

const StoreBadgeImg = styled('img')({
    width: '100%',
    height: 'auto',
    display: 'block',
    borderRadius: '8px',
});

const SectionTitle = styled(Typography)({
    fontSize: '17px',
    fontWeight: 700,
    color: '#111827',
    marginBottom: '28px',
    paddingBottom: '12px',
    letterSpacing: '-0.4px',
    position: 'relative',
    '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '40px',
        height: '3px',
        background: 'linear-gradient(90deg, #0066FF 0%, transparent 100%)',
        borderRadius: 2,
    },
    '@media (max-width: 480px)': {
        fontSize: '15px',
        marginBottom: '18px',
    },
});

const LinksList = styled('ul')({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    '& li': {
        marginBottom: '14px',
    },
});

const FooterLink = styled(MuiLink)({
    color: '#6B7280',
    fontSize: '15px',
    textDecoration: 'none',
    transition: 'color 0.2s ease',
    '&:hover': {
        color: '#0066FF',
    },
    '@media (max-width: 480px)': {
        fontSize: '14px',
    },
});

const ContactBlock = styled(Box)({
    marginBottom: '20px',
    '&:last-of-type': {
        marginBottom: 0,
    },
});

const ContactLabel = styled(Typography)({
    fontSize: '12px',
    fontWeight: 700,
    color: '#0066FF',
    textTransform: 'uppercase',
    letterSpacing: '0.8px',
    marginBottom: '8px',
});

const FooterBottom = styled(Box)({
    padding: '24px 0',
    background: 'rgba(0, 102, 255, 0.02)',
    marginLeft: 'calc(-50vw + 50%)',
    marginRight: 'calc(-50vw + 50%)',
    paddingLeft: 'max(24px, calc(50vw - 600px + 24px))',
    paddingRight: 'max(24px, calc(50vw - 600px + 24px))',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width: 768px)': {
        padding: '20px 24px',
        marginLeft: 0,
        marginRight: 0,
        paddingLeft: 24,
        paddingRight: 24,
        textAlign: 'center',
    },
    '@media (max-width: 480px)': {
        padding: '18px 16px',
    },
});

const BottomBarLinks = styled(Box)({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px 12px',
});

const BottomBarSep = styled('span')({
    color: '#9CA3AF',
    fontSize: '14px',
    userSelect: 'none',
});

export default Footer;
